import React, { useEffect, useState } from 'react';
import { Container, Card, CardMedia, CircularProgress, Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getPosts } from '../actions/posts';
import useStyles from '../styles';
import Carousel from 'react-material-ui-carousel';



const Home = () => {

    
    const posts = useSelector((state) => state.posts);
    const classes = useStyles();
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(getPosts());
    }, [dispatch]
    );

    return (
        <Container className={classes.home}>

        
            {!posts.length ? <CircularProgress /> : (
                <Carousel
                    className={classes.carousel}
                    autoPlay={true}
                    navButtonsAlwaysVisible={true}
                    animation={'fade'} interval={5000}
                    timeout={2000}
                    >
                    {posts.map((post, i) => <Item key={i} post={post} />)}

                </Carousel>
            )}
        </Container>
    );
};

export default Home;


function Item(props) {
    const classes = useStyles();
    const dim = getSize(props.post.size);

    return (

        <Container
            className={classes.carousel}
            sx={{
                maxWidth: (dim.w * 15).toString() + 'px',
                maxHeight: (dim.h * 15).toString() + 'px'

            }}
        >
            <Card sx={{ backgroundColor: 'transparent', boxShadow: 'none',position: 'relative' }}>
                <Paper className={classes.paper_legend}>
                    <Typography className={classes.legend_text}>{props.post.title}</Typography>
                    <Typography className={classes.legend_text}>{props.post.size}</Typography>
                    <Typography className={classes.legend_text}>{props.post.price}</Typography>
                </Paper>
                
                <CardMedia 
                    className={classes.carouselImage}
                    image={props.post.selectedFile}
                    sx={{
                        
                        aspectRatio: dim.aspect.toString(),
                        width: (dim.w * 15).toString() + 'px',
                        height: (dim.h * 15).toString() + 'px'
                        
                    }}
                     />
                
            </Card>
        </Container>

    )
}

function getSize(size) {
    let dim = {
        aspect: "0.0",
        h: "0",
        w: "0"
    }
    
    const sizes = size.split('x');
    dim.h = sizes[0];
    dim.w = sizes[1];
    if (sizes[0] > sizes[1]) {
        dim.aspect = sizes[0] / sizes[1];
        
    } else {
        dim.aspect = sizes[1] / sizes[0];
    }

    return dim;
}

